import styled from "styled-components";
import { colors } from "../../theme/color";
import React from "react";

export const CustomLabel: React.FC<React.LabelHTMLAttributes<any>> = ({
  title,
  children,
  ...props
}) => {
  return <Label {...props}>{children || title}</Label>;
};

export const Label = styled.label`
  color: ${colors.neutral.jet};
  font-family: "GT Walsheim Pro";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 171.429% */
  letter-spacing: 0.28px;
`;
export default CustomLabel;
